<div class="iq-pricing-5 iq-ptb-40" [ngClass]="active ? 'active' : ''">
  <div class="pricing-header iq-mb-30">
    <h6 class="iq-tw-6 iq-mb-10 text-capitalize">{{ item.title }}</h6>
    <h3 class="iq-tw-6">{{ item.price }}</h3>
  </div>
  <ng-content select="[cardBody]"></ng-content>
  <ng-content select="[cardFooter]"></ng-content>
</div>
